module.exports = __webpack_public_path__ + "img/6d.64494c4b.png";